import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { WidthDirective } from '../../directives/width.directive';
import { heightDirective } from '../../directives/height.directive';
import { AvatarColorPipe } from '../../pipes/avatar-color.pipe';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [
    WidthDirective,
    heightDirective,
    AvatarColorPipe
  ],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent extends BaseComponent {

  @Input({ required: true }) text: string;
  @Input() email: string;
  @Input() showDeleteButton = false;
  @Input({ required: true }) size: number;
  @Input({ required: true }) selectable: boolean;
  @Input() set selected(val: boolean) {
    this._selected = val;
    this.cdr.detectChanges();
  };

  @Output() selectedChange = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<string>();

  private _selected: boolean;

  public get selected(): boolean {
    return this._selected;
  }
}
